<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_bc14"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button @click="funcAdd('add')">
          新增
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      export-config
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      sort-config.remote
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          field="roleName"
          title="角色名称"
          min-width="80"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roleName"
            placeholder="请输入角色名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="角色类型"
          min-width="100"
          :formatter="formatterType"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.type" clearable placeholder="请选择">
            <el-option
              v-for="(item, index) in typeList"
              :key="'typeList' + item.value + index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="description"
          title="备注"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.description"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="funcAdd('details', scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.type == '0'"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcAdd('edit', scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.type == '0'"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="授权" placement="top">
            <vxe-button type="text" @click="funcPermission(scope.row.code)">
              <i class="el-icon-setting" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="授权通知"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcAuthorizeNotice(scope.row.code)"
            >
              <i class="el-icon-bell" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="APP授权通知"
            placement="top"
          >
            <vxe-button type="text" @click="funcAppNotice(scope.row.code)">
              <i class="el-icon-bell" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-if="isCompanyShipmentOrAdmin"
      v-model="modelAddFlag"
      :title="modeladdTitle"
      width="500"
      height="300"
      resize
    >
      <compAdd
        ref="addRef"
        :parent-data="parentData"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-if="isCompanyShipmentOrAdmin"
      v-model="modelPermissionFlag"
      title="角色授权"
      width="450"
      height="750"
      resize
    >
      <compPermission
        ref="permissionRef"
        :parent-data="parentData"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-if="isCompanyShipmentOrAdmin"
      v-model="modelNoticeFlag"
      title="授权通知"
      width="400"
      height="800"
      resize
    >
      <compNotice
        ref="noticeRef"
        :parent-data="parentData"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-if="isCompanyShipmentOrAdmin"
      v-model="modelappNoticeFlag"
      title="app授权通知"
      width="400"
      height="800"
      resize
    >
      <appNotice
        ref="appnoticeRef"
        :parent-data="parentData"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/roleAdd";
import compPermission from "./components/rolePermission";
import compNotice from "./components/roleNotice";
import appNotice from "./components/appNotice";
import request from "@/utils/request";
export default {
  name: "JurisdictManage",
  components: {
    compAdd,
    compPermission,
    compNotice,
    appNotice
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          partyCode: "",
          branchCode: ""
        };
      }
    }
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/role/exportRole", //导出接口
        name: "权限管理"
      },
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modeladdTitle: "新增",
      modelNoticeFlag: false,
      modelPermissionFlag: false,
      modelappNoticeFlag: false,
      isCompanyShipmentOrAdmin: false,
      copy: false,
      listQuery: {
        shipmentCode: "",
        branchCode: "",
        role: "",
        roleName: "",
        type: "",
        description: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 类型
      typeList: [
        { label: "托运人添加", value: 0 },
        { label: "内置角色", value: 1 },
        { label: "内置托运人员工角色", value: 2 }
      ]
    };
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isCompanyShipmentOrAdmin = partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.listQuery.shipmentCode = this.parentData.partyCode;
    this.listQuery.branchCode = this.parentData.branchCode;
  },
  methods: {
    findList() {
      return new Promise(resolve => {
        this.loading = true;
        request({
          url: "/ntocc-basic-api/role",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 添加方法
    funcAdd(type, code) {
      this.modelAddFlag = true;
      this.modeladdTitle =
        type == "add" ? "新增" : type == "edit" ? "编辑" : "详情";
      this.$refs.addRef.getInfo(type, code);
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/role`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "permission":
          this.modelPermissionFlag = false;
          break;
        case "notice":
          this.modelNoticeFlag = false;
          break;
        case "appNotice":
          this.modelappNoticeFlag = false;
          break;
        default:
      }
    },
    // 翻译类型
    formatterType({ cellValue }) {
      const item = this.typeList.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 授权
    funcPermission(code) {
      this.$refs.permissionRef.getInfo(code);
      this.modelPermissionFlag = true;
    },
    // 授权通知
    funcAuthorizeNotice(code) {
      this.$refs.noticeRef.getInfo(code);
      this.modelNoticeFlag = true;
    },
    // 授权通知
    funcAppNotice(code) {
      this.$refs.appnoticeRef.getInfo(code);
      this.modelappNoticeFlag = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
